import type { components, Country } from '@heidi/schema/template-gallery';

import { requireIntegrationsDataPort } from '../../../document-inbox/data/config';
import type { IntegrationProviderOption } from '../../contracts/types';

type IntegrationProvidersWireResponse =
  components['schemas']['IntegrationProviderListResponse'];

/**
 * The injected globalHttp instance has no default timeout, so without this a
 * stalled request leaves the provider dropdowns pending forever. 30s matches
 * the inbox-service deadline.
 */
const INTEGRATION_PROVIDERS_TIMEOUT_MS = 30_000;

/**
 * `GET /template-gallery/integrations-marketplace/integrations/integration-providers?country=`
 * returns the country-scoped EHR/EMR provider list. Unauthenticated: rides
 * the injected template-gallery client, never the scribe registry. `country`
 * is the schema's ISO alpha-2 enum; the service 422s on anything else
 * (e.g. `UK` where it wants `GB`).
 */
export const getIntegrationProviders = async (
  country: Country
): Promise<IntegrationProviderOption[]> => {
  const http = await requireIntegrationsDataPort('loadTemplateGalleryHttp')();
  const { data } = await http.get<IntegrationProvidersWireResponse>(
    '/template-gallery/integrations-marketplace/integrations/integration-providers',
    { params: { country }, timeout: INTEGRATION_PROVIDERS_TIMEOUT_MS }
  );
  return data.integrationProviders.map((provider) => ({
    uniqueId: provider.unique_id,
    name: provider.name,
  }));
};
